import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { FaExclamationTriangle, FaTimes } from 'react-icons/fa';
import './ConfirmModal.css';

const ConfirmModal = ({ isOpen, onClose, onConfirm, title, message, confirmText = 'Delete', cancelText = 'Cancel', type = 'danger' }) => {
  if (!isOpen) return null;

  return (
    <AnimatePresence>
      <motion.div
        className="confirm-modal-overlay"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        onClick={onClose}
      >
        <motion.div
          className="confirm-modal-content"
          initial={{ scale: 0.9, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          exit={{ scale: 0.9, opacity: 0 }}
          onClick={(e) => e.stopPropagation()}
        >
          <button className="confirm-modal-close" onClick={onClose}>
            <FaTimes />
          </button>

          <div className={`confirm-modal-icon ${type}`}>
            <FaExclamationTriangle />
          </div>

          <h2 className="confirm-modal-title">{title}</h2>
          <p className="confirm-modal-message">{message}</p>

          <div className="confirm-modal-actions">
            <button
              className="btn btn-cancel"
              onClick={onClose}
            >
              {cancelText}
            </button>
            <button
              className={`btn btn-confirm btn-${type}`}
              onClick={() => {
                onConfirm();
                onClose();
              }}
            >
              {confirmText}
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default ConfirmModal;
